import { useState } from "react";
import { colorOptions } from "../../data/colors";

interface ColorSelectorProps {
    defaultColor: string;
    setColor: CallableFunction;
}

export function ColorSelector(props: ColorSelectorProps) {
    const [color, setColor] = useState(props.defaultColor);

    const handleColorClick = (event: any) => {
        const value = event.currentTarget.dataset.value;
        setColor(value);
        props.setColor(value);
    }

    return (
        <div className="color-selector">
            { colorOptions.map((c: any) => {
                return <div className={ 'color-item' + (c.value == color ? ' selected' : '') } 
                    data-value={ c.value } onClick={ handleColorClick } style={{backgroundColor: c.value }}>
                    </div>
            })}
        </div>
    );
}